<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.66 17.43">
    <defs></defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="transport">
        <line class="cls-1" x1="0.46" y1="0.46" x2="24.2" y2="0.46" />
        <line class="cls-1" x1="0.46" y1="16.98" x2="24.2" y2="16.98" />
        <line class="cls-1" x1="0.46" y1="8.72" x2="24.2" y2="8.72" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.cls-1 {
  fill: #fff;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
